import EmptyPredictionsCmp from '@porterin/booking-flow/src/order-review/view/components/EmptyPredictionsCmp';
import React from 'react';
import AddressPredictionsCmpDesktop from './AddressPredictionsCmpDesktop';

export interface AddressPredictionsViewCmpProps {
  predictions: google.maps.places.AutocompletePrediction[];
  on_prediction_click: (
    prediction: google.maps.places.AutocompletePrediction,
  ) => void;
}

const AddressPredictionsViewCmpDesktop: React.FC<
  AddressPredictionsViewCmpProps
> = ({ predictions, on_prediction_click }) => {
  return predictions.length === 0 ? (
    <EmptyPredictionsCmp />
  ) : (
    <AddressPredictionsCmpDesktop
      predictions={predictions}
      on_prediction_click={on_prediction_click}
    />
  );
};

export default AddressPredictionsViewCmpDesktop;
